<template>
  <div class="wrapper-createUser wrapper-createUser--updateUser">
    <headView
      v-if="$route.params.id"
      class="disable-add-user"
      :option="updateUserObj"
      :subtitleOpt="subtitleOpt"
    ></headView>
    <headView v-else class="disable-add-user" :option="createUserObj" :subtitleOpt="subtitleOpt"></headView>
    <div class="list-CreatedUser">
      <div class="wrap-user">
        <form @submit.prevent="validateV('formUser')" data-vv-scope="formUser">
          <b-field
            class="content-field"
            :type="errors.has('formUser.nombre') ? 'is-danger': ''"
            :message="errors.has('formUser.nombre') ? errors.first('formUser.nombre') : ''"
          >
            <b-input
              name="nombre"
              class="input-custom input-custom--high input-custom--createUser"
              placeholder="Nombres"
              v-model="user.firstName"
              v-validate="'required|alpha_spaces'"
              :disabled="!role"
            ></b-input>
          </b-field>
          <b-field
            class="content-field"
            :type="errors.has('formUser.apellidos') ? 'is-danger': ''"
            :message="errors.has('formUser.apellidos') ? errors.first('formUser.apellidos') : ''"
          >
            <b-input
              name="apellidos"
              class="input-custom input-custom--high input-custom--createUser"
              placeholder="Apellidos"
              v-model="user.lastName"
              v-validate="'required|alpha_spaces'"
              :disabled="!role"
            ></b-input>
          </b-field>
          <b-field
            class="content-field"
            :type="errors.has('formUser.documento') ? 'is-danger': ''"
            :message="errors.has('formUser.documento') ? errors.first('formUser.documento') : ''"
          >
            <b-input
              name="documento"
              class="input-custom input-custom--high input-custom--createUser"
              placeholder="DNI"
              v-model="user.document"
              v-validate="'required|numeric'"
              :disabled="!role"
            ></b-input>
          </b-field>
          <b-field
            class="content-field"
            :type="errors.has('formUser.email') ? 'is-danger': ''"
            :message="errors.has('formUser.email') ? errors.first('formUser.email') : ''"
          >
            <b-input
              class="input-custom input-custom--high input-custom--createUser"
              placeholder="Correo Electrónico"
              type="email"
              v-model="user.email"
              v-validate="'required|email'"
              autocomplete="off"
              :disabled="!role"
            ></b-input>
          </b-field>

          <b-field
            class="content-field"
            :type="errors.has('formUser.contraseña') ? 'is-danger': ''"
            :message="errors.has('formUser.contraseña') ? errors.first('formUser.contraseña') : ''"
            v-if="$route.name != 'usersMasterCreate' && $route.name != 'updateUserMaster'"
          >
            <b-input
              class="input-custom input-custom--high input-custom--createUser"
              placeholder="Contraseña"
              type="password"
              v-model="user.password"
              v-validate="'required'"
              autocomplete="off"
              :disabled="!role"
            ></b-input>
          </b-field>
          <b-field
            class="content-field password-field"
            :type="errors.has('formUser.contraseña') ? 'is-danger': ''"
            :message="errors.has('formUser.contraseña') ? errors.first('formUser.contraseña') : ''"
            v-else
          >
            <b-input
              name="contraseña"
              class="input-custom input-custom--high input-custom--createUser"
              placeholder="Contraseña"
              type="password"
              v-model="user.password"
              v-validate="'required'"
              :disabled="!checkbox"
            ></b-input>
            <b-checkbox v-model="checkbox">Active la edicion de contraseña.</b-checkbox>
          </b-field>
          <b-field
            class="content-field"
            :type="errors.has('formUser.rol') ? 'is-danger': ''"
            :message="errors.has('formUser.rol') ? errors.first('formUser.rol') : ''"
            v-if="$route.name != 'usersMasterCreate' && $route.name != 'updateUserMaster'"
          >
            <b-select
              data-vv-name="rol"
              class="input-select-custom"
              placeholder="Tipo de acceso"
              v-model="user.role"
              v-validate="'required'"
              :disabled="!role"
            >
              <option value="app">App</option>
              <option value="supervisor">Supervisor</option>
              <option value="observer">Visor</option>
              <option value="master">Master</option>
            </b-select>
          </b-field>
          <b-field
            class="content-field"
            :type="errors.has('formUser.estado') ? 'is-danger': ''"
            :message="errors.has('formUser.estado') ? errors.first('formUser.estado') : ''"
            v-if="$route.name != 'usersMasterCreate' && $route.name != 'updateUserMaster'"
          >
            <b-select
              data-vv-name="estado"
              class="input-select-custom"
              placeholder="Estado"
              v-model="user.status"
              v-validate="'required'"
              :disabled="!role"
            >
              <option value="enabled">Activo</option>
              <option value="disabled">Inactivo</option>
            </b-select>
          </b-field>
          <div
            class="wrap-warning"
            v-if="$route.name != 'usersMasterCreate' && $route.name != 'updateUserMaster'"
          >
            <h6 class="warning">¡Atención!</h6>
            <p>Los estados determinan el tipo de acceso que tienen los usuarios de la plataforma.</p>
            <h6 class="warning">Master:</h6>
            <p>Acceso a toda la plataforma. Puede crear, editar y borrar</p>
            <h6 class="warning">Supervisor:</h6>
            <p>Puede ver la Web y usar la app de tareas. Adicionalmente recibe alertas de notificaciones. No puede crear, editar o borrar</p>
            <h6 class="warning">Visor:</h6>
            <p>Solo puede ver la Web. No puede crear, editar o borrar</p>
            <h6 class="warning">App:</h6>
            <p class="last">Acceso solo a la app de tareas</p>
          </div>
          <div class="wrap-btn-content" v-if="role">
            <button
              class="button button-custom ripple btn-action wrap-btn-content--one"
              type="buttom"
              @click="backToListUser"
            >Cancelar</button>
            <!-- <button  class="button button-custom ripple btn-action wrap-btn-content--two" @click="PutUser()" v-if="!$route.params.id">Guardar nuevo usuario</button> -->
            <button
              class="button button-custom ripple btn-action wrap-btn-content--two"
              type="submit"
              v-if="!$route.params.id"
            >Guardar nuevo usuario</button>
            <button
              class="button button-custom ripple btn-action wrap-btn-content--two"
              type="submit"
              v-if="$route.params.id"
            >Actualizar usuario</button>
            <a
              class="button button-custom ripple btn-action wrap-btn-content--three"
              type="buttom"
              @click="preventDialogCU()"
              v-if="$route.params.id"
            >Eliminar usuario</a>
          </div>
        </form>
      </div>
    </div>
    <div
      class="list-CreatedUser list-CreatedUser--wrapUpdateUser"
      v-if="($route.params.id)"
    >
      <edificio-c-p v-if="user.buildings" :currentBuild="user.buildings" :viewActive="viewLocal"/>
      <!-- <a @click="verCheckBuild()">ver lista</a> -->
    </div>
  </div>
</template>

<script>
import "@/assets/styles/1.settings/colors.scss";
import headView from "../Componentes/headView";
import { mapGetters } from "vuex";
import { service } from "@/helper/Rest";
import EdificioCP from "../Main/PuntoControlEdificio";
export default {
  name: "createdUser",
  components: {
    headView,
    EdificioCP
  },
  data() {
    return {
      openSwatches: false,
      createUserObj: {
        headText: "Usuarios y permisos",
        valueBtn: "nuevo usuario",
        subtitle: "Nuevo Usuario",
        btnAction: false
      },
      updateUserObj: {
        headText: "Usuarios y permisos",

        subtitle: "",
        btnAction: false
      },
      subtitleOpt: true,
      colorPrimaryEditable: "rgb(56, 74, 93)",
      colorx: "#C8C8C8",
      colorx2: "#2BBB9C",
      checkbox: false,
      user: {
        status: "enabled"
      },
      valueBtn: "nuevo usuario",
      viewLocal: "updateUser",
      dataString: "Este campo es requerido.",
      userValidate: false,
      firstNameError: false,
      lastNameError: false,
      documentError: false,
      emailError: false,
      passwordError: false,
      roleError: false,
      statusError: false,
      active: false
    };
  },
  watch: {
    // newUser: function(newval, oldval) {
    //   console.log({newval, oldval});
    //   if(!this.$route.params.id){
    //     this.user = newval;
    //     this.updateUserObj.subtitle =
    //       this.user.firstName + " " + this.user.lastName;
    //   }
    // }
  },
  computed: {
    ...mapGetters(["listBuild", "role"])
  },
  async created() {
    console.log(this.$route.name);

    if (this.$route.params.id) {
      if (this.$route.name == "updateUserMaster") {
        this.$store.dispatch("GETOWNERDETAIL", this.$route.params.id);
      } else {
        this.user = await this.$store.dispatch("GETUSERINCOMPANY", {
          user_id: this.$route.params.id,
          business_id: this.$store.getters.company_id
        });
      }
    }
  },
  methods: {
    backToListUser: function() {
      if (
        this.$route.name == "usersMasterCreate" ||
        this.$route.name == "updateUserMaster"
      ) {
        this.$router.push({ name: "usersMaster" });
      } else {
        this.$router.push({ name: "listuser" });
      }
    },
    validateV(scope) {
      console.log("asas", this.$route.name);

      this.$validator.validateAll(scope).then(result => {
        if (result) {
          this.PutUser();
        }
      });
    },
    PutUser: function() {
      if (this.$route.name == "usersMasterCreate") {
        this.$store.commit("addNewUser", {
          firstName: this.user.firstName,
          lastName: this.user.lastName,
          document: this.user.document,
          email: this.user.email,
          password: this.user.password
        });
      } else {
        this.$store.commit("addNewUser", this.user);
      }
      if (!this.$route.params.id) {
        if (this.$route.name == "usersMasterCreate") {
          service
            .createBusinessOwner(this.$store.state.newuser)
            .then(response => {
              // service.getUsers(this.$store.getters.company_id).then(response => {
              //   this.$store.commit("addUsers", response.data);
              // });
              this.backToListUser();
              this.$toast.open({
                message: "Usuario creado",
                position: "is-bottom-right",
                type: "ffcolor-is-success"
              });
            })
            .catch(error => console.warn(error));
        } else {
          service
            .postUser(this.$store.getters.company_id, this.$store.state.newuser, this.$store.state.namespace)
            .then(response => {
              service
                .getUsers(this.$store.getters.company_id, this.$store.state.namespace)
                .then(response => {
                  this.$store.commit("addUsers", response.data);
                });
              this.backToListUser();
              this.$toast.open({
                message: "Usuario creado",
                position: "is-bottom-right",
                type: "ffcolor-is-success"
              });
            })
            .catch(error => console.warn(error));
        }
      } else {
        if (this.$route.name == "updateUserMaster") {
          service
            .updateBusinessOwner({
              id: this.$route.params.id,
              data: this.$store.state.newuser
            })
            .then(response => {
              this.backToListUser();
              this.$toast.open({
                message: "Usuario actualizado",
                position: "is-bottom-right",
                type: "ffcolor-is-success"
              });
              service
                .getUsers(this.$store.getters.company_id)
                .then(response => {
                  this.$store.commit("addUsers", response.data);
                });
            })
            .catch(error => console.warn(error));
        } else {
          service
            .putUser(
              this.$store.getters.company_id,
              this.$route.params.id,
              this.$store.state.newuser
            )
            .then(response => {
              this.backToListUser();
              this.$toast.open({
                message: "Usuario actualizado",
                position: "is-bottom-right",
                type: "ffcolor-is-success"
              });
              service
                .getUsers(this.$store.getters.company_id)
                .then(response => {
                  this.$store.commit("addUsers", response.data);
                });
            })
            .catch(error => console.warn(error));
        }
      }
    },
    preventDialogCU() {
      this.$dialog.confirm({
        title: "Usuarios",
        message:
          "Se eliminará el usuario del sistema.</br> <strong>¿Desea continuar?</strong>",
        confirmText: "Ok",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => this.deleteUser()
      });
    },
    deleteUser: function() {
      service
        .delUsuario(this.$route.params.id, this.$store.getters.companyID)
        .then(response => {
          this.backToListUser();
          this.$toast.open({
            message: "Usuario eliminado",
            position: "is-bottom-right",
            type: "ffcolor-is-delete"
          });
        });
    },
    actionVerify() {
      this.openSwatches = !this.openSwatches;
    }
  }
};
</script>

<style lang="scss">
.disable-add-user {
  .btn-render-plus {
    display: none !important;
  }
}
.wrapper-createUser {
  position: relative;
  &--updateUser {
    display: flex;
  }
}
.list-CreatedUser {
  padding: 20px;
  padding-top: 80px;
  max-width: 500px;
  &--wrapUpdateUser {
    width: 100%;
  }
  .wrap-user {
    // .input-high {
    //   input {
    //     height: 3.25em;
    //   }
    // }
    // .con-input {
    //   margin-top: 0;
    //   margin-left: 0;
    //   margin-right: 0;
    //   .vs-input {
    //     border-radius: 3px;
    //   }
    //   .placeholder {
    //     color: #4e4e4e;
    //   }
    // }
    // .con-select {
    //   margin-bottom: 10px;
    //   .inputx {
    //     color: #4e4e4e;
    //     width: 100%;
    //     border-radius: 3px;
    //   }
    //   .icon-select {
    //     top: 8px;
    //   }
    // }
    .wrap-warning {
      padding: 10px;
      text-align: left;
      border-radius: 3px;
      border: 1px solid #dbdbdb;
      box-shadow: 0px 0px 0.5px 0px rgba(0, 0, 0, 0.75);
      font-size: 16px;
      color: #bdbdbd;
      margin-bottom: 1rem;
      h6 {
        font-size: 16px;
        font-weight: normal;
        margin: 0;
      }
      p {
        margin-bottom: 10px;
      }
      .last {
        margin-bottom: 0;
      }
      .warning {
        color: #5e5e5e;
      }
    }
    .wrap-btn-content {
      padding: 10px 0;
      display: flex;
      flex-flow: row wrap;
      width: 460px;
      .btn-action {
        border-radius: 3px;
        width: 220px;
        // margin-left: 0;
        // margin-right: 0;
      }
      &--one {
        margin-left: 0;
        margin-right: 10px;
        background-color: #c9c9c9;
      }
      &--two {
        margin-right: 0;
        margin-left: 10px;
        background-color: #1abc9c;
      }
      &--three {
        margin-top: 20px;
        // margin-right: 0;
        // margin-left: 10px;
        background-color: #d0021b;
      }
    }
  }
}
.type-select {
  .help {
    text-align: left;
  }
  .input-custom--min {
    .input {
      &:hover {
        border-color: #b5b5b5;
      }
      &:active,
      &:focus {
        border-color: transparent;
      }
    }
  }
}
.content-field {
  position: relative;
  .input-custom {
    &--createUser {
      .icon {
        color: #ff3860 !important;
        top: 8px;
      }
    }
    width: 100%;
    .is-danger {
      &:focus {
        border-color: #ff3860;
      }
    }
  }
}
.warning-show {
  text-align: left;
  margin: -10px 0 7px 4px;
  font-size: 13px;
  color: #ff3860;
}
.password-field{
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: flex-start;
}
</style>



// WEBPACK FOOTER //
// src/components/Main/createUser.vue